import { useSetAtom } from 'jotai';
import useAuthAPI from '../../api/auth';
import { userDataAtom, userRolesAtom } from '../../Atoms';
import { askNotificationPermission } from '../../Helpers/notifications';

// Loads the signed-in user and their roles into the atoms; logs out when there is no session.
export default function useLoadUserSession() {
  const AuthAPI = useAuthAPI();
  const setUserData = useSetAtom(userDataAtom);
  const setUserRoles = useSetAtom(userRolesAtom);

  return (onUserLoaded, onFailure) =>
    AuthAPI.getUserInfo(
      (result) => {
        setUserData(result);
        if (onUserLoaded) onUserLoaded();
        AuthAPI.getUserRoles((roles) => {
          setUserRoles(roles);
          askNotificationPermission();
        });
      },
      () => {
        AuthAPI.logout();
        if (onFailure) onFailure();
      }
    );
}
